import { RootState } from "../../../utils/types/root-state";


export const getErrorRequestState = (state: RootState) => state.errorRequest;
